import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./DashboardLogin.css";

const DashboardLogin = () => {

  const navigate = useNavigate();

  const [email,setEmail] = useState("");
  const [otp,setOtp] = useState("");
  const [step,setStep] = useState("email");
  const [loading,setLoading] = useState(false);
  const [timer,setTimer] = useState(0);
  const [error,setError] = useState("");

  const isLoggedIn = localStorage.getItem("rg_auth") === "1";
  const storedEmail = localStorage.getItem("rg_email");

  /* ================= AUTO LOGIN REDIRECT ================= */

  useEffect(()=>{
    if(isLoggedIn){
      setStep("logged");
    }
  },[]);

  /* ================= OTP TIMER ================= */

  useEffect(()=>{

    if(timer === 0) return;

    const interval = setInterval(()=>{
      setTimer(prev => prev - 1);
    },1000);

    return ()=> clearInterval(interval);

  },[timer]);

  /* ================= SEND OTP ================= */

  const handleSendOtp = async ()=>{

    setError("");

    if(!email){
      setError("Enter valid email");
      return;
    }

    try{

      setLoading(true);

      const res = await axios.post("/auth/send-otp",{
        email: email.trim().toLowerCase()
      });

      if(res.data.success){

        setStep("otp");
        setTimer(30);

      }

    }catch(err){

      setError("Access restricted. This feature is available for Bootcamp members.");

    }finally{

      setLoading(false);

    }

  };

  /* ================= VERIFY OTP ================= */

  const handleVerifyOtp = async ()=>{

    setError("");

    if(!otp || otp.length !== 6){
      setError("Enter valid 6 digit OTP");
      return;
    }

    try{

      setLoading(true);

      const res = await axios.post("/auth/verify-otp",{
        email,
        otp
      });

      if(res.data.success){

        localStorage.setItem("rg_email",email);
        localStorage.setItem("rg_auth","1");
        localStorage.setItem("user_email", email);

        setStep("logged");

       navigate("/reactiongame");

      }

    }catch(err){

      setError("Invalid or expired OTP");

    }finally{

      setLoading(false);

    }

  };

  /* ================= RESEND OTP ================= */

  const resendOtp = ()=>{

    if(timer === 0){

      handleSendOtp();

    }

  };

  /* ================= LOGOUT ================= */

  const handleLogout = ()=>{

    localStorage.removeItem("rg_auth");
    localStorage.removeItem("rg_email");

    setStep("email");
    setEmail("");
    setOtp("");
    setError("");

  };

  return (

    <div className="dashboard-container">

      {/* MAIN TITLE */}
      <h1 className="dashboard-main-title">
        ForgeYourPeak Dashboard
      </h1>

      <div className="dashboard-card">

        <h3 className="dashboard-subtitle">
         Sign in to access your performance insightss
        </h3>

        {/* ================= EMAIL STEP ================= */}

        {step === "email" && (

          <>

            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e)=>setEmail(e.target.value)}
              className="dashboard-input"
            />

            {error && (
              <div className="dashboard-error">
                {error}
              </div>
            )}

            <button
              className="dashboard-button"
              onClick={handleSendOtp}
              disabled={loading}
            >
              {loading ? "Sending OTP..." : "Send OTP"}
            </button>

            <button
              className="get-access-btn"
              onClick={()=>window.open(
                "https://learn.forgeyourpeak.in/web/checkout/698a8ef1831f481067f8b8f1",
                "_blank"
              )}
            >
              Get Access
            </button>

          </>

        )}

        {/* ================= OTP STEP ================= */}

        {step === "otp" && (

          <>

            <input
              type="text"
              placeholder="Enter 6 digit OTP"
              value={otp}
              onChange={(e)=>setOtp(e.target.value.replace(/\D/g,""))}
              maxLength="6"
              className="dashboard-input"
            />

            {error && (
              <div className="dashboard-error">
                {error}
              </div>
            )}

            <button
              className="dashboard-button"
              onClick={handleVerifyOtp}
              disabled={loading}
            >
              {loading ? "Verifying..." : "Verify OTP"}
            </button>

            <div className="otp-resend">

              {timer > 0 ? (
                <span>Resend OTP in {timer}s</span>
              ) : (
                <button onClick={resendOtp}>
                  Resend OTP
                </button>
              )}

            </div>

          </>

        )}

        {/* ================= LOGGED VIEW ================= */}

        {step === "logged" && (

          <div className="dashboard-logged">

            <p className="dashboard-success">
              Logged in as
            </p>

            <p className="dashboard-user">
              {storedEmail}
            </p>

            <button
              className="dashboard-button"
              onClick={()=>navigate("/reactiongame")}
            >
              Go to Reaction Game
            </button>

            <button
              className="dashboard-logout"
              onClick={handleLogout}
            >
              Logout
            </button>

          </div>

        )}

      </div>

    </div>

  );

};

export default DashboardLogin;